<!-- ----------------------------------------------- -->
<template>
  <v-row class="switch-btn pr-4 pl-4 pb-1">
    <span class="sns-style">
      <tm-sns
        v-if="!isReduction"
        :dispContentsSwitch="isNotCamera(tabIndex)"
      ></tm-sns>
    </span>
    <v-spacer></v-spacer>
    <span class="pt-2" v-if="!(reqParam.itmkndCd === 4 && tabIndex === 2)">
      <span v-if="dispZoom(0)">
        <!-- 全体 -->
        <v-btn
          v-if="scalModeXSec != null && scalModeGraph != null"
          tile
          depressed
          x-small
          class="btn-bk-color"
          color="success"
          min-width="0px"
          max-width="35px"
          :outlined="
            tabIndex === 0 ? scalModeXSec === true : scalModeGraph === true
          "
          @click="
            tabIndex === 0 ? (scalModeXSec = false) : (scalModeGraph = false)
          "
        >
          <span>{{ btn.zoomout }}</span>
        </v-btn>
        <!-- 拡大 -->
        <v-btn
          v-if="scalModeXSec != null && scalModeGraph != null"
          tile
          depressed
          x-small
          class="btn-bk-color"
          color="success"
          min-width="0px"
          max-width="35px"
          :outlined="
            tabIndex === 0 ? scalModeXSec === false : scalModeGraph === false
          "
          @click="
            tabIndex === 0 ? (scalModeXSec = true) : (scalModeGraph = true)
          "
        >
          <span>{{ btn.zoomin }}</span>
        </v-btn>
      </span>
      <span v-if="dispZoom(1)">
        <!-- 全体 -->
        <v-btn
          v-if="scalMode != null"
          tile
          depressed
          x-small
          class="btn-bk-color"
          color="success"
          min-width="0px"
          max-width="35px"
          :outlined="scalMode === true"
          @click="scalMode = false"
        >
          <span>{{ btn.zoomout }}</span>
        </v-btn>
        <!-- 拡大 -->
        <v-btn
          v-if="scalMode != null"
          tile
          depressed
          x-small
          class="btn-bk-color"
          color="success"
          min-width="0px"
          max-width="35px"
          :outlined="scalMode === false"
          @click="scalMode = true"
        >
          <span>{{ btn.zoomin }}</span>
        </v-btn>
      </span>
      <span v-if="reqParam.itmkndCd !== 300">
        <!-- 時間 -->
        <v-btn
          v-if="timeMode != null"
          tile
          depressed
          x-small
          class="ml-1 btn-bk-color"
          color="success"
          min-width="0px"
          max-width="35px"
          :outlined="timeMode === false"
          @click="timeMode = true"
        >
          <span>{{ btn.timehour }}</span>
        </v-btn>
        <!-- 10分 -->
        <v-btn
          v-if="timeMode != null"
          tile
          depressed
          x-small
          class="btn-bk-color"
          color="success"
          min-width="0px"
          max-width="35px"
          :outlined="timeMode === true"
          @click="timeMode = false"
        >
          <span>{{ btn.time10 }}</span>
        </v-btn>
      </span>
      <span>
        <!-- 凡例 -->
        <v-btn
          v-if="this.dispLegend()"
          depressed
          x-small
          class="ml-1 mb-legend-btn"
          color="orange"
          max-width="55px"
          dark
          :outlined="!isLegendDisp"
          @click="isLegendDisp = !isLegendDisp"
        >
          {{ btn.legend }}
        </v-btn>
      </span>
    </span>
  </v-row>
</template>
<!-- ----------------------------------------------- -->
<script>
/**
 * 川の防災情報 [MB]個別観測所画面 表示切替ボタン
 * TmSwitchBtn.vue
 * @author ILUKE
 */
import TmSns from "./TmSns.vue";
export default {
  name: "tm-switch-btn",
  components: {
    TmSns,
  },
  data() {
    return {
      /** 文字列リソース */
      btn: {
        zoomout: "全体",
        zoomin: "拡大",
        timehour: "時間毎",
        time10: "10分毎",
        legend: "凡例",
      },
    };
  },
  props: {
    /** 観測詳細タブ */
    tabIndex: {
      type: Number,
      default: 0,
    },
  },
  computed: {
    // リクエストパラメータ
    reqParam: {
      get() {
        if (
          this.$store.state.Telemeter.selectedTmParam.itmkndCd &&
          Number(this.$route.query["itmkndCd"]) !== 300
        ) {
          return this.$store.state.Telemeter.selectedTmParam;
        } else {
          return this.$store.state.Swin.selectedSwParam;
        }
      },
    },
    // 拡縮表示設定 取得
    scalMode: {
      get() {
        return this.$store.state.Telemeter.scalMode;
      },
      set(val) {
        this.$store.commit("Telemeter/setScalMode", val);
      },
    },
    // 横断図拡縮表示設定 取得
    scalModeXSec: {
      get() {
        return this.$store.state.Telemeter.scalModeXSec;
      },
      set(val) {
        this.$store.commit("Telemeter/setScalModeXSec", val);
      },
    },
    // グラフ拡縮表示設定 取得
    scalModeGraph: {
      get() {
        return this.$store.state.Telemeter.scalModeGraph;
      },
      set(val) {
        this.$store.commit("Telemeter/setScalModeGraph", val);
      },
    },
    // 表示時刻設定 取得
    timeMode: {
      get() {
        return this.$store.state.Telemeter.timeMode;
      },
      set(val) {
        this.$store.commit("Telemeter/setTimeMode", val);
      },
    },
    /** 凡例表示状態 取得 */
    isLegendDisp: {
      get() {
        return this.$store.state.Telemeter.isLegendDisp;
      },
      set(val) {
        this.$store.commit("Telemeter/setLegendDisp", val);
      },
    },
    /** 簡易版判定 */
    isReduction: {
      get() {
        return global.KWB_MODE == "reduction";
      },
    },
  },
  methods: {
    /**
     * カメラ画面で無いか
     */
    isNotCamera(tabIndex) {
      if (
        (this.reqParam.itmkndCd === 4 && tabIndex === 2) ||
        (this.reqParam.itmkndCd === 300 && tabIndex === 2)
      ) {
        // カメラ画像の場合はfalseを返す
        return false;
      } else {
        return true;
      }
    },
    /**
     * 全体拡大ボタンを出力するか判定する
     * @param type 0の場合は水位観測/水位計、1の場合はそれ以外
     */
    dispZoom(type) {
      if (type === 0) {
        if (this.reqParam.itmkndCd != 4 && this.reqParam.itmkndCd != 300) {
          return false;
        }
        if (this.tabIndex < 2) {
          return true;
        }
      } else {
        if (this.reqParam.itmkndCd === 4 || this.reqParam.itmkndCd === 300) {
          return false;
        }
        if (
          this.reqParam.itmkndCd === 1 ||
          this.reqParam.itmkndCd === 2 ||
          this.reqParam.itmkndCd === 3 ||
          this.reqParam.itmkndCd === 6 ||
          this.reqParam.itmkndCd === 12 ||
          this.reqParam.itmkndCd === 20 ||
          this.reqParam.itmkndCd === 21
        ) {
          // 雨量/流域平均雨量/積雪/水質/海岸/レーダ流域平均雨量
          if (this.tabIndex != 1) {
            return true;
          }
        } else if (this.reqParam.itmkndCd === 7) {
          // ダム諸量
          if (this.tabIndex === 1) {
            return true;
          }
        } else if (this.tabIndex < 2) {
          return true;
        }
      }
      return false;
    },
    /**
     * 凡例を出力するか判定する
     */
    dispLegend() {
      if (this.isLegendDisp === null) {
        return false;
      }
      if (
        this.reqParam.itmkndCd === 1 ||
        this.reqParam.itmkndCd === 2 ||
        this.reqParam.itmkndCd === 3 ||
        this.reqParam.itmkndCd === 6 ||
        this.reqParam.itmkndCd === 12 ||
        this.reqParam.itmkndCd === 20 ||
        this.reqParam.itmkndCd === 21
      ) {
        // 雨量/流域平均雨量/積雪/水質/海岸/レーダ流域平均雨量
        if (this.tabIndex != 1) {
          return true;
        }
      } else if (this.reqParam.itmkndCd === 7) {
        // ダム諸量
        if (this.tabIndex === 1) {
          return true;
        }
      } else if (this.tabIndex < 2) {
        return true;
      }
      return false;
    },
  },
};
</script>
<!-- ----------------------------------------------- -->
<style lang="scss" scoped>
.switch-btn {
  text-align: right;
  .btn-bk-color {
    background-color: white;
  }
}
.sns-style {
  width: 110px !important;
}
</style>
